import AnonymousWhatIsPremiumRoutes from "./routes/SubRouter";

function AnonymousWhatIsPremiumRoute() {
  return <AnonymousWhatIsPremiumRoutes />;
}

export default AnonymousWhatIsPremiumRoute;
